import { Box } from '@veracity/vui'

import { PageContainer, PageSearchInput } from '@/components'
import { useCurrentUser, useFilterDatasets } from '@/hooks'

import {
  AddIncomeAdjustmentDatasetDialog,
  IncomeAdjustmentDatasetsTable
} from './components'
import { useIncomeAdjustments } from './hooks'

export const IncomeAdjustmentPage = () => {
  const { isUser } = useCurrentUser()
  const { incomeAdjustmentDatasets, isFetching } = useIncomeAdjustments()

  const { filteredDatasets, onFilterChange } = useFilterDatasets(
    incomeAdjustmentDatasets
  )

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[
            { title: 'Library' },
            { title: 'Income Adjustment (Coming Soon)' }
          ]}
        />
      }
      menuBar={
        <Box justify="space-between" w="100%">
          <PageSearchInput onChange={onFilterChange} />
          {isUser && <AddIncomeAdjustmentDatasetDialog />}
        </Box>
      }>
      <IncomeAdjustmentDatasetsTable datasets={filteredDatasets} />
    </PageContainer>
  )
}
